import { otherApiClient } from ".";
// 캐시 잔액 조회
export const getCashBalance = async ()=>{
    const { data  } = await otherApiClient.market.get("/cash/balance/cash");
    return data;
};
// 캐시 상품 목록 조회
export const getCashProducts = async ()=>{
    const { data  } = await otherApiClient.market.get("/cash/products");
    return data;
};
export const getCashProductById = async (id)=>{
    const { data  } = await otherApiClient.market.get("/cash/products/".concat(id));
    return data;
};
// 캐시 거래 내역 조회
export const getCashTransactions = async (params)=>{
    const { data  } = await otherApiClient.market.get("/cash/transactions/cash", {
        params
    });
    return data;
};
// 포인트 잔액 조회
export const getPointBalance = async ()=>{
    const { data  } = await otherApiClient.market.get("/cash/balance/point");
    return data;
};
// 포인트 거래 내역 조회
export const getPointTransactions = async (params)=>{
    const { data  } = await otherApiClient.market.get("/cash/transactions/point", {
        params
    });
    return data;
};
